// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__5LVo6","left":"StickyBox_left__2Ythz","right":"StickyBox_right__3PbI7"};